import { sendFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';

const BASE_PATH = '/product-price';

export const findProductsPriceByClient = async (client) => {
    return await sendSellerFetch(`${BASE_PATH}/all/client/${client}`, GET_OPTIONS);
}

export const createProductPrice = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editProductPrice = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}